import { gql, TypedDocumentNode } from '@apollo/client';

type BackInStockNotificationMutation = {
  __typename: 'BackInStockNotificationMutation';
  backInStockNotificationMutation: {
    success: true;
  };
};

type BackInStockNotificationMutationInput = {
  email: string;
  sku: number;
};

type BackInStockNotificationMutationVariables = {
  input: BackInStockNotificationMutationInput;
};

export const BACK_IN_STOCK_NOTIFICATION_MUTATION: TypedDocumentNode<
  BackInStockNotificationMutation,
  BackInStockNotificationMutationVariables
> = gql`
  mutation BackInStockNotificationMutation($input: BackInStockNotificationMutationInput) {
    backInStockNotificationMutation(input: $input)
      @rest(
        type: "BackInStockNotificationMutation"
        endpoint: "moda"
        path: "/v3.5/users/set_email_back_in_stock"
        method: "POST"
      ) {
      success
    }
  }
`;
